module.exports = __webpack_public_path__ + "media/images/number_5-fde7b02eeb7767bd8dd360766f837b0d.png";